var videoModule = (function ($) {
    'use strict';
    var $vidModal = $("#vid-modal");
    var wistiaEmbed;

    var settings = {
        videoTrigger: '.js-video-trigger',
        videoScriptAdded: false,
    };

    var _videotrigger = function () {

        $(settings.videoTrigger).on('click', function (e) {
            e.preventDefault();
            var el = $(this);

            $(el).addClass('loading');
            if (settings.videoScriptAdded == false) {
                // If Wistia script hasn't been loaded yet load it.
                _intialiseWistiaScript(el);
            } else if (settings.videoScriptAdded == true) {
                // If Wistia script has been loaded then carry out video modal function.
                playVideoModalHandler(el);
            }

        });
    };

    var _intialiseWistiaScript = function (el) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.onload = function () {
            // Cleanup onload handler
            script.onload = null;
            settings.videoScriptAdded = true;
            // Now Wistia script has finsihed loading carry out the video model function.
            revealVideoModalHandler(el);

        };
        script.onerror = function () {
            alert('Opps, something went wrong please come back later and try again!');
        };

        // Add the script to the DOM
        document.getElementsByTagName('head')[0].appendChild(script);

        // Set the `src` to begin transport
        script.src = "//fast.wistia.net/assets/external/E-v1.js";
    };

    var revealVideoModalHandler = function (el) {
        var wistiaID = $(el).data('wistia-id');

        window._wq = window._wq || [];
        _wq.push({
            id: wistiaID,
            options: {
                videoFoam: true,
                popoverShowOnLoad: true,
                playbar: true,
                popoverPreventScroll: true,
            },
        });
    };

    var playVideoModalHandler = function (el) {
        var wistiaID = $(el).data('wistia-id'),
            video = Wistia.api(wistiaID);

        video.popover.show();
        video.play();
    };

    function init() {
        _videotrigger();
    }

    return {
        init: init,
    };
}(jQuery));

jQuery(document).ready(function ($) {
    if ($('.js-video-trigger').length > 0) {
        videoModule.init();
    }
});
